module.exports = __webpack_public_path__ + "static/media/welcome_bdan.dd7caa89.png";